import {IStore} from "modules/types";
import {createSelector} from "reselect";

export const getPredictionResultStore = ({prediction_result}: IStore) => prediction_result;
export const getBracketPredictionResultByIDSelector = createSelector(
	getPredictionResultStore,
	(prediction_result) => (bracketID: number) => prediction_result[bracketID]
);
